/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const orgHealthResponseSchema = z.object({
  activeItemCount: z.int(),
  allotment: z.int().nullish(),
  avgNetChangePerDay: z.number().nullish(),
  computedAt: z.iso.datetime(),
  daysOfHistory: z.int(),
  state: z.string().nullish(),
});
